module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search'), _vm._v(" "), (_vm.isLoadingProjects) ? _c('loading-icon', {
    staticClass: "loading-animation prepend-top-20",
    attrs: {
      "size": "2",
      "label": _vm.s__('ProjectsDropdown|Loading projects')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFrequentsListVisible) ? _c('div', {
    staticClass: "section-header"
  }, [_vm._v("\n    " + _vm._s(_vm.s__('ProjectsDropdown|Frequently visited')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isFrequentsListVisible) ? _c('projects-list-frequent', {
    attrs: {
      "local-storage-failed": _vm.isLocalStorageFailed,
      "projects": _vm.frequentProjects
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSearchListVisible) ? _c('projects-list-search', {
    attrs: {
      "search-failed": _vm.isSearchFailed,
      "matcher": _vm.searchQuery,
      "projects": _vm.searchProjects
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8728b10"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/app.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c8728b10"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/app.vue
// module chunks = main